import { render, staticRenderFns } from "./modelTemplate.vue?vue&type=template&id=0ecd8916&scoped=true"
import script from "./modelTemplate.vue?vue&type=script&lang=js"
export * from "./modelTemplate.vue?vue&type=script&lang=js"
import style0 from "./modelTemplate.vue?vue&type=style&index=0&id=0ecd8916&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd8916",
  null
  
)

export default component.exports